import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	setFormula
} from '../redux/file-actions';

import Button from './Button';

class FormulaControl extends Component {
	constructor(props) {
		super(props);
		
		let obj = this.props.exampleValues;
		let cols = Object.keys(obj).map(function (key) { return obj[key]; });

		this.state = {
			varKeys: this.props.headerSelection.map((h, i) => {
				return String.fromCharCode(65 + i) + " = " + this.props.headers[h].Header
			}),
			cols,
			values: this.props.headerSelection.map((v, i) => {
				return String.fromCharCode(65 + i) + " = " + cols[v];
			}),
			result: ""
		};

		this.evaluateExpression = this.evaluateExpression.bind(this);
		this.getElementsToDisplay = this.getElementsToDisplay.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		
		let obj = nextProps.exampleValues;
		let cols = Object.keys(obj).map(function (key) { return obj[key]; });
		this.setState((prevState, props) => {
			return {
				varKeys: nextProps.headerSelection.map((h, i) => {
					return String.fromCharCode(65 + i) + " = " + nextProps.headers[h].Header
				}),
				cols,
				values: nextProps.headerSelection.map((v, i) => {
					return String.fromCharCode(65 + i) + " = " + cols[v];
				})
			}
		});
	}
	getElementsToDisplay(vars) {
		let varDisplay = <div className="control">
			{
				this.state.varKeys.map((item, key) => {
					return <span key={key}>{item}<br/></span>
				})
			}
		</div>;

		let formulaDisp = <div className="control">
			<input type="text" value={this.props.formula} onChange={(e) => {
				this.props.dispatch(setFormula(this.props.fileId, e.target.value))
			}} />
		</div>;

		let result = <span><b>Result</b>: {this.state.result}<br/></span>

		let exampleDisp = <div className="control">
			<h5>Example</h5>
			<pre>
				{
					this.state.values.map((item, key) => {
						return <span key={key}>{item}<br/></span>
					})
				}
				 <span>{this.props.formula}<br/></span>
			</pre>
			{this.state.result && result}
		</div>;
		
		let evaluate = <div className="control">
			<Button onClick={this.evaluateExpression}>Evaluate</Button>
		</div>;
		
		let display = [varDisplay];

		if (this.props.headerSelection.length > 0) {
			display.push(formulaDisp);
		}

		if (this.props.formula.length > 0) {
			display.push(exampleDisp);
			display.push(evaluate);
		}	

		return display;
	}

	evaluateExpression(){
		let exp = "";

		for (let i = 0; i < this.state.values.length; i++) {
			exp += "var " + this.state.values[i] + ";";
		}

		exp = exp + this.props.formula;

		console.log(exp);

		let result = eval(exp);

		this.setState((prevState) => {
			return {result}
		});
	}

	render() {

		return <div>{this.getElementsToDisplay()}</div>;
	}
}

FormulaControl.propTypes = {
	fileId: PropTypes.string,
	dispatch: PropTypes.func,
	headers: PropTypes.array,
	headersSelection: PropTypes.array,
	formula: PropTypes.string,
	exampleValues: PropTypes.array,
}

export default FormulaControl;


// WEBPACK FOOTER //
// ./src/components/FormulaControl.js